<div class="cpb-container">
  <div class="cpb-card">
    <!-- Header -->
    <div class="cpb-header">
      <div class="cpb-header-title">
        <mat-icon class="cpb-header-icon">tune</mat-icon>
        <h1 class="cpb-title">{{ (isEdit() ? 'policy.editPage.title' : 'policy.overview.button.create.label') | transloco }}</h1>
      </div>
      <p class="cpb-subtitle">{{ (isEdit() ? 'policy.editPage.subtitle' : 'policy.createPage.subtitle') | transloco }}</p>
    </div>

    <!-- Role Selector -->
    <div class="cpb-section">
      <div class="role-selector">
        <span class="role-label">{{ 'policy.create.roleLabel' | transloco }}</span>
        <div class="role-toggle">
          <button mat-stroked-button
            [class.active]="role() === 'access'"
            (click)="selectRole('access')">
            <mat-icon>visibility</mat-icon>
            {{ 'policy.create.roleAccess' | transloco }}
          </button>
          <button mat-stroked-button
            [class.active]="role() === 'usage'"
            (click)="selectRole('usage')">
            <mat-icon>gavel</mat-icon>
            {{ 'policy.create.roleUsage' | transloco }}
          </button>
        </div>
      </div>
    </div>

    <!-- Policy ID -->
    <div class="cpb-section">
      <span class="cpb-label">{{ 'wizard.accessPolicy.policyId' | transloco }}</span>
      <mat-form-field appearance="outline" class="cpb-id-field">
        <mat-label>{{ 'wizard.accessPolicy.policyId' | transloco }}</mat-label>
        <input matInput [formControl]="policyIdCtrl" [readonly]="isEdit()"
               [placeholder]="'wizard.accessPolicy.policyId.placeholder' | transloco" />
        @if (policyIdCtrl.hasError('pattern')) {
          <mat-error>{{ 'wizard.accessPolicy.policyId.patternError' | transloco }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Policy Builder -->
    <div class="cpb-section">
      <span class="cpb-label">{{ 'wizard.accessPolicy.constraints' | transloco }}</span>
      <app-policy-builder
        [initialConstraints]="constraints()"
        [role]="role()"
        (constraintsChange)="onConstraintsChange($event)"
        (validChange)="onBuilderValidChange($event)"
      />
    </div>

    <!-- Actions -->
    <div class="cpb-actions">
      <button mat-button class="cpb-cancel-btn" (click)="cancel()">
        {{ 'dialog.button.cancel.label' | transloco }}
      </button>
      <button mat-flat-button color="primary"
              [disabled]="!isValid() || saving()"
              (click)="submit()">
        @if (saving()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>check</mat-icon>
        }
        {{ (isEdit() ? 'dialog.button.update.label' : 'dialog.button.create.label') | transloco }}
      </button>
    </div>
  </div>
</div>
